// Version : 0.0.2
// Author : AGALYA
// LAST EDIT DONE BY : Shiyam
// LastEdit : changes done in saga LOAN INDEX inserted
// MODFIED DATA : 23-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import overdueReportActionTypes from './over-due-report.types';
import { overdueReportDetailsGet } from './over-due-report.services';
import {
	getoverdueReportDetailsSuccess,
	getoverdueReportDetailsFailure,
	getoverdueReportDetailsResponseChanged,
} from './over-due-report.actions';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
/** ***************** GET OVERDUE REPORT DETAILS START *********************** */
export function* getoverdueReportList({ payload }: any) {
	// debugger;
	try {
		const key = 'GetoverdueReportKey';
		const jsonData = {
			LoanIndexType: payload.loanIndexType,
			CompanyID: payload.companyID,
			AreaID: payload.branchID,
			UserID: payload.userID,
			TillDate: payload.TillDate,
			UserLevel: payload.userLevel,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			CenterID: payload.centerID,
			GroupID: payload.groupID,
			UserRole: payload.userRole,
			DateFilter: payload.datefilter,
			OverDueListBy: payload.OverDueListBy,
			IsThriftExist: payload.IsThriftExist,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(overdueReportDetailsGet, encodeData, payload.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getoverdueReportDetailsFailure(responseData.data));
		} else {
			yield put(getoverdueReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getoverdueReportDetailsFailure(error));
	}
}

export function* resetGetOverDueReportListResponse() {
	yield put(getoverdueReportDetailsResponseChanged());
}

export function* onGetoverdueReportListDetails() {
	yield takeLatest(overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_START, getoverdueReportList);
}

export function* onGetoverdueReportListResponseReset() {
	yield takeLatest(
		overdueReportActionTypes.GET_OVERDUE_REPORT_LIST_RESPONSE_RESET,
		resetGetOverDueReportListResponse,
	);
}
/** ***************** GET OVERDUE REPORT DETAILS END *********************** */

export function* overDueReportSaga() {
	yield all([call(onGetoverdueReportListDetails), call(onGetoverdueReportListResponseReset)]);
}
